import React, { forwardRef } from "react";
import { TextAreaStyled } from "./style";
interface ItextAreaProps {
  className?: string;
  placeholder?: string;
  name?: string;
}
const TextArea = forwardRef<HTMLTextAreaElement, ItextAreaProps>(
  ({ className, placeholder, name }, ref) => (
    <TextAreaStyled
      ref={ref}
      placeholder={placeholder}
      className={className}
      name={name}
    ></TextAreaStyled>
  )
);

export default TextArea;
